/* eslint-disable react/no-unknown-property */
import React, { useMemo } from 'react';
import { useTexture, Line } from '@react-three/drei';
import * as THREE from 'three';

const EarthComponent = () => {
  const earthTexture = useTexture('/environments/gray3.jpg');
  const earthRadius = 10;

  // 저궤도 쉘용 위도/경도선 (반지름 sphereRadius+2)
  const leoLongitudeLines = useMemo(() => {
    return Array.from({ length: 18 }).map((_, i) => {
      const phi = (i / 18) * Math.PI * 2;
      const points = [];
      for (let t = 0; t <= 64; t++) {
        const theta = (t / 64) * Math.PI;
        const x = (earthRadius + 2) * Math.sin(theta) * Math.cos(phi);
        const y = (earthRadius + 2) * Math.cos(theta);
        const z = (earthRadius + 2) * Math.sin(theta) * Math.sin(phi);
        points.push(new THREE.Vector3(x, y, z));
      }
      return points;
    });
  }, [earthRadius]);

  const leoLatitudeLines = useMemo(() => {
    return Array.from({ length: 9 }).map((_, i) => {
      const theta = ((i + 1) / 10) * Math.PI;
      const points = [];
      for (let t = 0; t <= 64; t++) {
        const phi = (t / 64) * Math.PI * 2;
        const x = (earthRadius + 2) * Math.sin(theta) * Math.cos(phi);
        const y = (earthRadius + 2) * Math.cos(theta);
        const z = (earthRadius + 2) * Math.sin(theta) * Math.sin(phi);
        points.push(new THREE.Vector3(x, y, z));
      }
      return points;
    });
  }, [earthRadius]);

  return (
    <group>
      {/* 지구 구체 (고정) */}
      <mesh rotation={[0, -Math.PI / 2, 0]}>
        <sphereGeometry args={[earthRadius, 64, 64]} />
        <meshBasicMaterial 
          map={earthTexture}
        />
      </mesh>

      {/* 저궤도 영역 경도선 */}
      {leoLongitudeLines.map((points, i) => (
        <Line
          key={`leo-lon-${i}`}
          points={points}
          color="#d9d9d9"
          transparent
          opacity={0.5}
        />
      ))}

      {/* 저궤도 영역 위도선 */}
      {leoLatitudeLines.map((points, i) => (
        <Line
          key={`leo-lat-${i}`}
          points={points}
          color="#d9d9d9"
          transparent
          opacity={0.5}
        />
      ))}
    </group>
  );
};

export default EarthComponent; 